const STORAGE_KEY = 'espacoteca_filtros_atributo_v1';
import React, { useState, useEffect, useRef } from 'react';
import { Button, Checkbox, Dimmer, Dropdown, Header, Icon, Input, List, Loader, Modal, ModalActions, ModalContent, ModalDescription, ModalHeader, Popup } from 'semantic-ui-react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import {
    getAtributosListAction, getAtributosItemListAction, deleteAtributosItemListAction, postAtributoValorNewAction,
    deleteAtributoAction, editAtributoAction, changeTabAction, setAtributoSelecionado, getFabricanteListAction, getClassificacaoListAction,
    postClassificacaoNewAction, editClassificacaoAction, deleteClassificacaoAction
} from '../../../actions/EspacoTecaActions';
import PopupFiltro from './PopupFiltro';
import { ToastContainer, toast } from 'react-toastify';

/* --- MOVI OS STYLED-COMPONENTS PARA FORA DO COMPONENTE --- */
const CustomDropdown = styled(Dropdown)`
  &.ui.selection.dropdown:focus,
  &.ui.selection.dropdown.active {
    border-color: #102E3E !important;
    box-shadow: 0 0 0 1px #102E3E !important;
  }

  &.ui.selection.dropdown.active .dropdown.icon {
    color: #102E3E !important;
  }

  &.ui.selection.dropdown .menu {
    border: 2px solid #102E3E !important;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;
  }
`;

const FiltrosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  align-items: end;
  margin-bottom: 24px;
`;

const TableContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 20px;
  /* margin-left: 70px; */
`;

const StyledTable = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

  th {
    background-color: #102E3E;
    color: white;
    text-align: center;
    padding: 12px 16px;
    font-weight: 600;
    font-size: 14px;
  }

  td {
    padding: 12px 8px;
    font-size: 14px;
    color: #333;
    text-align: center;
    //width: 350px;
  }

  tbody tr {
    background-color: #f8f9fa;
    transition: background 0.3s;
  }

  tbody tr:nth-child(even) {
    background-color: #e9ecef;
  }

  
`;

const ButtonsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 35px;
  height: 10px;
  &:first-child {
    margin-top: 60px;
    height: 10px;
  }
`;

const WarningIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;

  i {
    font-size: 3rem;
    color: #f2c037; /* amarelo alerta */
  }
`;

const ModalText = styled.div`
  text-align: center;
  font-size: 1.05rem;
  color: #333;

  strong {
    font-weight: 600;
    color: #111;
  }
`;

const ProductList = styled(List)`
  margin-top: 1rem !important;
  text-align: left;
  background: #f9f9f9;
  border-radius: 10px;
  padding: 0.75rem 1rem;

  .item {
    font-size: 0.95rem;
    color: #444;
    padding: 4px 0;
  }
`;

const StyledModalHeader = styled(Modal.Header)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding-bottom: 0 !important;
  border-bottom: none !important; /* Remove a linha de separação padrão */
`;

const StyledModalContent = styled(Modal.Content)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
  /* padding-top: 0 !important; */
`;

const ModalTitle = styled.h2`
  font-weight: 700 !important;
  margin-top: '10px' !important;
  margin-bottom: 1em !important;
`;

const ModalMessage = styled.p`
  font-size: 1.1em !important;
  color: #555 !important;
  margin-bottom: 1.5em !important;
  max-width: 90%; /* Limita a largura para melhor leitura */
  line-height: 1.5;
`;

const ProductListWrapper = styled.div`
  width: 90% !important;
  max-height: 200px !important; /* Altura máxima para a lista rolável */
  overflow-y: auto !important; /* Adiciona scroll se a lista for muito grande */
  border: 1px solid #ddd !important;
  border-radius: 8px !important;
  padding: 1em !important;
  margin-bottom: 2em !important; /* Espaçamento antes dos botões */
  text-align: left !important; /* Alinha o texto da lista à esquerda */
`;

const ProductListItem = styled(List.Item)`
  font-size: 1em !important;
  line-height: 1.8 !important;
`;

const StyledModalActions = styled(Modal.Actions)`
  display: flex !important;
  justify-content: center !important;
  gap: 1rem !important; /* Espaço entre os botões */
  padding-bottom: 2em !important; /* Mais espaçamento na parte inferior */
  border-top: none !important; /* Remove a linha de separação padrão */
`;

const CancelButton = styled(Button)`
  background-color: #F0F0F0 !important; /* Cor de fundo neutra */
  color: #333 !important; /* Texto escuro */
  &:hover {
    background-color: #E0E0E0 !important;
  }
`;

const ConfirmDeleteButton = styled(Button)`
  background-color: #DB2828 !important; /* Vermelho para exclusão */
  color: white !important; /* Texto branco */
  &:hover {
    background-color: #C82020 !important;
  }
`;

const Classificacao = (props) => {
    const [rowHeights, setRowHeights] = useState([]);
    const tbodyRefs = useRef([]);
    const [showButtons, setShowButtons] = useState(false);
    const [filtros, setFiltros] = useState({
        atributoid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        atributo: '',
        observacao: ''
    });
    const [openIndex, setOpenIndex] = useState(null);
    const [adicionando, setAdicionando] = useState(false);
    const [novoAtributo, setNovoAtributo] = useState('');
    const [atributosLocais, setAtributosLocais] = useState([]); // cópia local dos itens
    const [editIndex, setEditIndex] = useState(null); // novo: controla qual linha está sendo editada
    const [editValue, setEditValue] = useState(''); // novo: valor temporário da edição
    const inputRef = useRef(null);
    const [atributosOriginais, setAtributosOriginais] = useState([]);
    const [isEdicao, setIsEdicao] = useState();
    const [open, setOpen] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [atributoValorIdExcluir, setAtributoValorIdExcluir] = useState();

    const { getAtributosListAction, getAtributosItemListAction, deleteAtributosItemListAction, postAtributoValorNewAction, deleteAtributoAction, editAtributoAction, changeTabAction, setAtributoSelecionado, classificacaoList, classificacaoListLoading } = props;
    const { atributosList, atributosListLoading, atributosItemList, atributosItemListLoading, deleteAtributosItemList, deleteAtributosItemListLoading,
        postAtributoAddNew, postAtributoAddNewLoading, editAtributoLoading, getClassificacaoListAction,
        postClassificacaoNewAction, editClassificacaoAction, deleteClassificacaoAction } = props;

    useEffect(() => {
        // reseta referências antes de medir
        tbodyRefs.current = [];

        getAtributosListAction();

        // timeout pequeno para garantir que o DOM foi atualizado antes de medir
        const timeout = setTimeout(() => {
            const validRows = tbodyRefs.current.filter(Boolean);
            const heights = validRows.map(row => row.getBoundingClientRect().height);
            setRowHeights(heights);
        }, 0);

        return () => clearTimeout(timeout);
    }, [classificacaoList]);

    // Sincroniza atributosLocais com a lista da store
    // IMPORTANTE: só sincroniza quando não estivermos no modo "adicionando"
    useEffect(() => {
        if (!adicionando) {
            const lista = Array.isArray(classificacaoList) ? classificacaoList : [];
            setAtributosLocais(lista);
            setAtributosOriginais(lista); // salva uma cópia original para restaurar depois
        }
    }, [classificacaoList, adicionando]);

    useEffect(() => {
        getClassificacaoListAction();
    }, [])

    // quando ativamos "adicionando", foca o input (apenas na transição para true)
    useEffect(() => {
        if (adicionando) {
            // pequeno timeout para garantir que o elemento já foi renderizado antes de focar
            const t = setTimeout(() => {
                if (inputRef.current && typeof inputRef.current.focus === 'function') {
                    inputRef.current.focus({ preventScroll: true });
                }
            }, 20);
            return () => clearTimeout(t);
        }
    }, [adicionando]);

    const buttonVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: { opacity: 1, x: 0 }
    };

    const atributoOptions = classificacaoList?.map((item) => ({
        key: item.classificacaoid,
        text: item.classificacaoid + ' ' + item.classificacao,
        value: item.classificacaoid
    })) || [];



    useEffect(() => {
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            if (!raw) return;

            const saved = JSON.parse(raw);
            if (saved && saved.atributoid) {
                // seta filtros localmente
                setFiltros(saved);

                // chama action para popular atributosItemList novamente
                0
                // opcional: se quiser mostrar imediatamente com base em atributosOriginais (se já tiver)
                // se atributosOriginais já estiverem preenchidos, aplica filtro localmente:
                if (Array.isArray(atributosOriginais) && atributosOriginais.length > 0) {
                    const filtrados = atributosOriginais.filter(it => {
                        // dependendo da estrutura de atributosOriginais, ajuste o campo:
                        // aqui assumo que cada item tem tecaatributoid ou similar
                        // mas normalmente getAtributosItemListAction vai repopular atributosItemList
                        return true; // deixei true — preferível recarregar via action para consistência
                    });
                    // setAtributosLocais(filtrados);
                }
            }
        } catch (err) {
            console.warn('Erro ao restaurar filtros do sessionStorage', err);
        }
        // eslint-disable-next-line
    }, []);


    const handleToggle = (index) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };

    const handleNovoAtributo = () => {
        setAdicionando(true);
        setNovoAtributo('');
    };

    const handleCancelarNovo = () => {
        setAdicionando(false);
        setNovoAtributo('');
    };

    const handleAdicionar = async () => {

        const resultado = await postClassificacaoNewAction(novoAtributo.trim(), null);

        setAdicionando(false);
        setNovoAtributo('');
        getClassificacaoListAction();

        // Agora usa o resultado DIRETAMENTE
        console.log('Resultado do add:', resultado[0].status);

        if (resultado[0].status === 'Sucesso') {

            toast.success(
                <div>
                    <p style={{ margin: 0 }}>Classificacao adicionada com sucesso!</p>
                    <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );

        } else {

            toast.error(
                <div>
                    <p style={{ margin: 0 }}>{resultado[0].message}</p>
                    <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );

        }

    };

    // NOVO: ao clicar em Editar
    const handleEditar = (index) => {
        setEditIndex(index);
        setEditValue(atributosLocais[index].classificacao);
        setIsEdicao(true);
    };

    const handleCancelarEdicao = () => {
        setEditIndex(null);
        setEditValue('');
        setIsEdicao(false);
    };

    const handleFiltroConfirm = (itensSelecionados) => {
        if (!itensSelecionados || itensSelecionados.length === 0) {
            // se nenhum filtro selecionado, restaura lista completa
            setAtributosLocais(atributosOriginais);
            return;
        }

        const filtrados = atributosOriginais.filter(item =>
            itensSelecionados.includes(item.classificacao)
        );

        console.log('FILTADOS ->', filtrados)

        setAtributosLocais(filtrados);
    };

    const handleCopiarDados = () => {
        if (!atributosLocais || atributosLocais.length === 0) {
            alert('Não há dados para copiar.');
            return;
        }

        // Cria o cabeçalho
        const header = ['Classificacao', 'Plural', 'Dimensão Altura', 'Dimensão Largura', 'Dimensão Comprimento', 'Produtos'];

        // Mapeia os dados da tabela
        const linhas = atributosLocais.map(item => [
            item.classificacao,
            item.plural,
            item.dim_altura,
            item.dim_largura,
            item.dim_comprimento,
            item.produtos
        ]);

        // Junta tudo em formato CSV simples (separado por tab, ideal para planilhas)
        const texto = [
            header.join('\t'),
            ...linhas.map(l => l.join('\t'))
        ].join('\n');

        // Copia para a área de transferência
        navigator.clipboard.writeText(texto)
            .then(() => {
                toast.success(
                    <div>
                        <p style={{ margin: 0 }}>Dados Copiados para área de transferência!</p>
                        <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                    </div>,
                    {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            background: "#fff",
                            color: "#000",
                        },
                    }
                );
            })
            .catch(err => {
                console.error('Erro ao copiar:', err);
                toast.error(
                    <div>
                        <p style={{ margin: 0 }}>Falha ao copiar dados! Tente novamente</p>
                        <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                    </div>,
                    {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            background: "#fff",
                            color: "#000",
                        },
                    }
                );
            });
    };

    const handleSalvarEdicao = async (index, item) => {
        setAtributosLocais(prev => {
            const newList = [...prev];
            newList[index].classificacao = editValue;
            return newList;
        });
        const resultado = await editClassificacaoAction(item.classificacaoid, editValue.trim(), item.plural || null);

        // Toast opcional (se você quiser)
        if (resultado[0]?.status === "Sucesso") {
            setEditIndex(null);
            setEditValue('');
            setIsEdicao(false);
            getClassificacaoListAction();
            toast.success(
                <div>
                    <p style={{ margin: 0 }}>Classificacao editada com sucesso!</p>
                    <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );
        } else {
            toast.error(
                <div>
                    <p style={{ margin: 0 }}>Erro ao editar classificacao.</p>
                    <small style={{ margin: 0 }}>{resultado[0]?.message}</small> <br />
                    <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );
        }
    };

    const handleExcluir = async () => {

        setLoadingDelete(true);

        // Aguarda realmente deletar!
        const resultado = await deleteClassificacaoAction(atributoValorIdExcluir);

        setLoadingDelete(false);
        setOpen(false);

        // Recarrega a lista depois de excluir!
        getClassificacaoListAction();

        console.log('Resultado do delete:', resultado);

        // Toast opcional (se você quiser)
        if (resultado[0]?.status === "Sucesso") {
            toast.success(
                <div>
                    <p style={{ margin: 0 }}>Classificacao removida com sucesso!</p>
                    <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );
        } else {
            toast.error(
                <div>
                    <p style={{ margin: 0 }}>Erro ao remover classificacao.</p>
                    <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );
        }
    };



    const handleOpenModalExcluir = (classificacaoid) => {
        setOpen(true);
        setAtributoValorIdExcluir(classificacaoid);
    };




    return (
        <div>
            <ToastContainer className='foo' />
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                size="small"
                style={{ borderRadius: '12px', padding: '1em' }} /* Ajustes no modal container */
            >
                <StyledModalHeader>
                    <ModalTitle>Confirmar Exclusão de Atributo</ModalTitle>
                </StyledModalHeader>

                <StyledModalContent>
                    <ModalMessage>
                        <strong>Atenção!</strong> Este atributo pode estar vinculado a alguns produtos.
                        Ao excluí-lo, esta informação será removida permanentemente deles. Deseja continuar?
                    </ModalMessage>

                    <ProductListWrapper>
                        <List bulleted>
                            <h4>Produtos Afetados ({deleteAtributosItemList.length})</h4>
                            {deleteAtributosItemListLoading ? (
                                <Dimmer active inverted>
                                    <Loader active>Carregando produtos...</Loader>
                                </Dimmer>
                            ) : (

                                deleteAtributosItemList.length > 0 ? (
                                    deleteAtributosItemList.map((produto, index) => (
                                        <ProductListItem key={index}>({produto.sku}) {produto.produto}</ProductListItem>
                                    ))
                                ) : (
                                    <ProductListItem>Nenhum produto afetado</ProductListItem>
                                )

                            )}
                        </List>
                    </ProductListWrapper>
                </StyledModalContent>

                <StyledModalActions>
                    <CancelButton onClick={() => setOpen(false)}>
                        Cancelar
                    </CancelButton>
                    <ConfirmDeleteButton loading={loadingDelete} onClick={handleExcluir}>
                        Excluir Permanentemente
                    </ConfirmDeleteButton>
                </StyledModalActions>
            </Modal>


            {
                classificacaoListLoading === false ? (
                    <>
                        {!adicionando && (
                            <div style={{ display: 'flex', marginTop: '5px', marginLeft: '70px', width: '570px', justifyContent: 'flex-end' }}>
                                <Button style={{ backgroundColor: '#102E3E', color: "#fff", marginRight: '10px' }} onClick={handleCopiarDados}>
                                    <Icon name="copy" />
                                    Copiar dados
                                </Button>
                                <PopupFiltro
                                    atributosLocais={atributosLocais}
                                    onConfirm={handleFiltroConfirm} // <-- adiciona isso
                                />
                                <Button style={{ backgroundColor: '#102E3E', color: "#fff" }} onClick={handleNovoAtributo}>
                                    <Icon name="plus" />
                                    Novo Valor
                                </Button>
                            </div>
                        )}
                        <TableContainer>
                            <StyledTable style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>Classificação</th>
                                        <th>Plural</th>
                                        <th>Altura</th>
                                        <th>Largura</th>
                                        <th>Comprimento</th>
                                        <th>Produtos</th>
                                        <th style={{ width: '205px' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Linha de novo atributo (key fixa) */}
                                    {adicionando && (
                                        <tr key="novo-atributo">
                                            <td>
                                                <Input
                                                    ref={inputRef}
                                                    placeholder="Novo valor..."
                                                    value={novoAtributo}
                                                    onChange={(e) => setNovoAtributo(e.target.value)}
                                                    style={{ width: '100%' }}
                                                />
                                            </td>
                                            <td>
                                                0
                                            </td>
                                            <td>
                                                0
                                            </td>
                                            <td>
                                                0
                                            </td>
                                            <td>
                                                0
                                            </td>
                                            <td>
                                                0
                                            </td>
                                            <td>

                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Button size="mini" loading={postAtributoAddNewLoading} color="green" onClick={handleAdicionar}>Adicionar</Button>
                                                    <Button size="mini" color="grey" onClick={handleCancelarNovo}>Cancelar</Button>
                                                </div>

                                            </td>
                                        </tr>
                                    )}

                                    {/* renderiza a lista local (atributosLocais) */}
                                    {atributosLocais.map((item, index) => {
                                        const key = index;
                                        return (
                                            <tr key={key} ref={el => tbodyRefs.current[index] = el}>
                                                <td>
                                                    {editIndex === index ? (
                                                        <Input
                                                            ref={inputRef}
                                                            value={editValue}
                                                            onChange={(e) => setEditValue(e.target.value)}
                                                            style={{ width: '100%' }}
                                                        />
                                                    ) : (
                                                        item.classificacao
                                                    )}
                                                </td>
                                                <td>{item.plural}</td>
                                                <td>{item.dim_altura}</td>
                                                <td>{item.dim_largura}</td>
                                                <td>{item.dim_comprimento}</td>
                                                <td>{item.produtos}</td>
                                                <td>
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        {!adicionando && (


                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                {openIndex === index ? (
                                                                    <div>
                                                                        <Icon
                                                                            name="close"
                                                                            style={{ cursor: 'pointer', color: 'red' }}
                                                                            onClick={() => { handleToggle(index); handleCancelarEdicao() }}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <Icon
                                                                        name="edit"
                                                                        size="small"
                                                                        style={{ cursor: 'pointer', color: '#102E3E', marginTop: isEdicao && index > openIndex ? '20px' : atributosItemList.length > 5 ? '0px' : '-5px' }}
                                                                        onClick={() => handleToggle(index)}
                                                                    />
                                                                )}

                                                                {openIndex === index && (
                                                                    <div>
                                                                        <motion.div
                                                                            initial="hidden"
                                                                            animate="visible"
                                                                            exit="hidden"
                                                                            variants={buttonVariants}
                                                                            // transition={{ duration: 0.3 }}
                                                                            style={{ display: 'flex', marginLeft: '10px' }}
                                                                        >
                                                                            {editIndex === index ? (
                                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <Button size="mini" color="green" loading={editAtributoLoading} onClick={() => handleSalvarEdicao(index, item)}>Salvar</Button>
                                                                                    <Button size="mini" color="grey" onClick={handleCancelarEdicao}>Cancelar</Button>
                                                                                </div>

                                                                            ) : (
                                                                                <>
                                                                                    <Button onClick={() => handleEditar(index)} size="mini" color="blue">Editar</Button>
                                                                                    <Button onClick={() => handleOpenModalExcluir(item.classificacaoid)} size="mini" color="red">Excluir</Button>
                                                                                </>
                                                                            )}
                                                                        </motion.div>
                                                                    </div>
                                                                )}
                                                            </div>


                                                        )}
                                                    </div>

                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </StyledTable>
                        </TableContainer>
                    </>
                ) : (
                    <div style={{ marginTop: '200px' }}>
                        <Dimmer active inverted>
                            <Loader active>Carregando itens...</Loader>
                        </Dimmer>
                    </div>
                )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    atributosList: state.EspacoTecaReducer.atributosList,
    atributosListLoading: state.EspacoTecaReducer.atributosListLoading,
    atributosItemList: state.EspacoTecaReducer.atributosItemList,
    atributosItemListLoading: state.EspacoTecaReducer.atributosItemListLoading,
    deleteAtributosItemList: state.EspacoTecaReducer.deleteAtributosItemList,
    deleteAtributosItemListLoading: state.EspacoTecaReducer.deleteAtributosItemListLoading,
    postAtributoAddNew: state.EspacoTecaReducer.postAtributoAddNew,
    postAtributoAddNewLoading: state.EspacoTecaReducer.postAtributoAddNewLoading,
    editAtributoLoading: state.EspacoTecaReducer.editAtributoLoading,
    tabindex: state.EspacoTecaReducer.tabindex,
    classificacaoList: state.EspacoTecaReducer.classificacaoList,
    classificacaoListLoading: state.EspacoTecaReducer.classificacaoListLoading,
});

export default withRouter(connect(mapStateToProps, {
    getAtributosListAction,
    getAtributosItemListAction,
    deleteAtributosItemListAction,
    deleteAtributoAction,
    editAtributoAction,
    postAtributoValorNewAction,
    changeTabAction,
    setAtributoSelecionado,
    getClassificacaoListAction,
    postClassificacaoNewAction,
    editClassificacaoAction,
    deleteClassificacaoAction
})(Classificacao));
